const initialState = {
    isReadingMappingFields: false,
    mapping_fields: null,
    automation_fields: null,
    groupWhereFieldIsBeingAdded: null
}

export default initialState;
